import React, { Component } from 'react'
import { Link } from 'react-router-dom';

// components
import Sidemenu from '../../../components/sidemenu'
import Header from '../../../components/dashHeader'

//css 
import '../../styles/dashboard/Home.css'

// assets
import Arrow from '../../../assets/icons/forward.svg'
import Back from '../../../assets/svg/back-arrow.svg'
//import Bank from '../../../assets/svg/other/provid.svg'



export default class BankTransfer extends Component {


    render() {

        const currentPage = "Home";

        return (
            <div>
                <Sidemenu currentPage={currentPage} />
                <Header />

                <section className="home">
                    <div className="home-container">
                        <div className="home-buy-content">
                            <Link to="/dashboard/homefundwallet">
                            <img src={Back} className="w-backarrow" alt="back" />
                            </Link>
                            <h1> Fund Wallet </h1>
                            <div className="home-nav">
                                <Link to="/dashboard/home" className="right-e"><p className="ash"> Home </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <Link to="/dashboard/homefundwallet" className="right-e"><p className="ash"> Fund Wallet </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <p><span className="bold"> Bank Transfer</span></p>
                            </div>
                            {/* <div className="p3buy-content">
                                <p className="p3buy-title both-m0">Fund your wallet via bank tranfer by sending funds to this Providus account</p>
                            </div> */}

                            {/* <div className="bt-box">
                                <div className="bt-bank-box">
                                    <img src={Bank} alt="account"/>
                                    <p className="bank-text"> Providus Account Number </p>
                                    <h2> 9923813490 </h2>
                                </div>
                               
                                <button className="bt-btn" type="submit">Copy account details</button>
                            </div> */}
                            
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
